import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ERequestDemandActionTypes } from '../../constants/actionTypes/requestDemand';
import { ICreateMessageForOfferRequest } from '../../repositories/demand/v2/create-message-for-offer';
import { EUserType } from '../../constants/requestDemand';

export const openDemandRequestModal = actionGenerator<ERequestDemandActionTypes.OPEN_DEMAND_REQUEST_MODAL, void>(
  ERequestDemandActionTypes.OPEN_DEMAND_REQUEST_MODAL,
);
export const closeDemandRequestModal = actionGenerator<ERequestDemandActionTypes.CLOSE_DEMAND_REQUEST_MODAL, void>(
  ERequestDemandActionTypes.CLOSE_DEMAND_REQUEST_MODAL,
);
export const openDemandSmsVerificationModal = actionGenerator<
  ERequestDemandActionTypes.OPEN_DEMAND_SMS_VERIFICATION_MODAL,
  void
>(ERequestDemandActionTypes.OPEN_DEMAND_SMS_VERIFICATION_MODAL);
export const closeDemandSmsVerificationModal = actionGenerator<
  ERequestDemandActionTypes.CLOSE_DEMAND_SMS_VERIFICATION_MODAL,
  void
>(ERequestDemandActionTypes.CLOSE_DEMAND_SMS_VERIFICATION_MODAL);
export const openDemandSuccessModal = actionGenerator<ERequestDemandActionTypes.OPEN_DEMAND_SUCCESS_MODAL, void>(
  ERequestDemandActionTypes.OPEN_DEMAND_SUCCESS_MODAL,
);
export const closeDemandSuccessModal = actionGenerator<ERequestDemandActionTypes.CLOSE_DEMAND_SUCCESS_MODAL, void>(
  ERequestDemandActionTypes.CLOSE_DEMAND_SUCCESS_MODAL,
);
export const demandRequestSendStart = actionGenerator<
  ERequestDemandActionTypes.DEMAND_REQUEST_SEND_START,
  ICreateMessageForOfferRequest
>(ERequestDemandActionTypes.DEMAND_REQUEST_SEND_START);
export const demandRequestSendError = actionGenerator<ERequestDemandActionTypes.DEMAND_REQUEST_SEND_ERROR, string>(
  ERequestDemandActionTypes.DEMAND_REQUEST_SEND_ERROR,
);
export const demandRequestSendSuccess = actionGenerator<ERequestDemandActionTypes.DEMAND_REQUEST_SEND_SUCCESS, void>(
  ERequestDemandActionTypes.DEMAND_REQUEST_SEND_SUCCESS,
);
export const changeUserType = actionGenerator<ERequestDemandActionTypes.DEMAND_CHANGE_USER_TYPE, EUserType>(
  ERequestDemandActionTypes.DEMAND_CHANGE_USER_TYPE,
);

export type TDemandRequestActions =
  | ReturnType<typeof openDemandRequestModal>
  | ReturnType<typeof closeDemandRequestModal>
  | ReturnType<typeof openDemandSuccessModal>
  | ReturnType<typeof openDemandSmsVerificationModal>
  | ReturnType<typeof closeDemandSmsVerificationModal>
  | ReturnType<typeof closeDemandSuccessModal>
  | ReturnType<typeof demandRequestSendStart>
  | ReturnType<typeof demandRequestSendError>
  | ReturnType<typeof demandRequestSendSuccess>
  | ReturnType<typeof changeUserType>;
